/**
 * parentalPinZapperModal.tsx
 */
import ChannelDown from '../../elements/images/channelDown';
import ChannelUp from '../../elements/images/channelUp';
import Container from '../../atoms/container/modalContainer';
import ExtraTitle from '../../atoms/text/modalExtraTitle';
import Input from '../../elements/modal/parentalPinInput';
import Logo from '../../atoms/images/modalLogo';
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useCloseModalKeyboard from '@shared/components/utils/hooks/useCloseModalKeyboard';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useState } from 'react';

/**
 * Displays the parental pin zapper modal.
 */
export default function ParentalPinZapperModal() {
  const { currentChannel } = useAppSelector(channelsSelector);
  const [error, setError] = useState(false);

  useCloseModalKeyboard({ pop: true });

  return (
    <Container>
      <ChannelUp />
      <Logo src={currentChannel?.logo} />
      <Title>{TranslationManager.get('MODAL.PARENTAL_PIN.TITLE')}</Title>
      <Subtitle>
        {TranslationManager.get('MODAL.PARENTAL_PIN.ZAPPER_SUBTITLE_INPUT')}
      </Subtitle>
      <Input callback={() => setError(true)} />
      {error ? (
        <ExtraTitle>
          {TranslationManager.get('MODAL.PARENTAL_PIN.ERROR')}
        </ExtraTitle>
      ) : null}
      <ChannelDown />
    </Container>
  );
}
